/* eslint no-param-reassign: "off" */

import { createSlice } from '@reduxjs/toolkit';
import {
  addCategory,
  getCategories,
  updateCategory,
  removeCategory,
} from './categoryService';

export const categorySlice = createSlice({
  name: 'category',
  initialState: {
    loading: 'idle',
    items: [],
    currentRequestId: undefined,
    error: null,
  },
  reducers: {},
  extraReducers: {
    [addCategory.pending]: (state, action) => {
      if (state.loading === 'idle') {
        state.loading = 'pending';
        state.currentRequestId = action.meta.requestId;
      }
    },
    [addCategory.fulfilled]: (state, action) => {
      const { requestId } = action.meta;
      if (state.loading === 'pending' && state.currentRequestId === requestId) {
        state.loading = 'idle';
        state.items.push(action.payload);
        state.currentRequestId = undefined;
      }
    },
    [addCategory.rejected]: (state, action) => {
      const { requestId } = action.meta;
      if (state.loading === 'pending' && state.currentRequestId === requestId) {
        state.loading = 'idle';
        state.error = action.error;
        state.currentRequestId = undefined;
      }
    },
    [getCategories.pending]: (state, action) => {
      if (state.loading === 'idle') {
        state.loading = 'pending';
        state.currentRequestId = action.meta.requestId;
      }
    },
    [getCategories.fulfilled]: (state, action) => {
      const { requestId } = action.meta;
      if (state.loading === 'pending' && state.currentRequestId === requestId) {
        state.loading = 'idle';
        state.items.splice(0);
        state.items.push(...action.payload);
        state.currentRequestId = undefined;
      }
    },
    [getCategories.rejected]: (state, action) => {
      const { requestId } = action.meta;
      if (state.loading === 'pending' && state.currentRequestId === requestId) {
        state.loading = 'idle';
        state.error = action.error;
        state.currentRequestId = undefined;
      }
    },
    [updateCategory.fulfilled]: (state, action) => {
      state.items = state.items.filter(
        (item) => item.id !== action.payload.categoryId,
      );
    },
    [removeCategory.fulfilled]: (state, action) => {
      state.items = state.items.filter(
        (item) => item.id !== action.payload.categoryId,
      );
    },
  },
});

export const selectCategories = (state) => state.category.items;

export default categorySlice.reducer;
